import React from "react";
const PaymentBreakdownModal = ({
  paymentDetails,
  total,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div
        className="payment-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="payment-modal-header">
          <h4>Payment Details</h4>

          <button onClick={onClose}>×</button>
        </div>

        <div className="payment-modal-body">
          {Object.entries(paymentDetails || {}).map(([key, value]) => {
          
            const amount=value||0;
            const label = key||"-";

            return (
              <div className="payment-row" key={key}>
                <span>{label.charAt(0).toUpperCase() + label.slice(1)}</span>
                <span>₹{amount}</span>
              </div>
            );
          })}

          <div className="payment-divider" />

          <div className="payment-total">
            <span>Total Amount</span>
            <strong>₹{total.toLocaleString("en-IN")}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentBreakdownModal;